/**
 * Card-Primitive — gerundetes Surface-Panel mit optionalem Padding.
 * Quelle: §10.18 Extraktion aus project-detail.tsx (Primitives-Block).
 */
import type { ReactNode } from 'react';

export function Card({ children, padding = true }: { children: ReactNode; padding?: boolean }) {
  return (
    <div
      className="rounded-xl border"
      style={{
        background: 'var(--surface)',
        borderColor: 'var(--line-soft)',
        boxShadow: 'var(--shadow-card)',
        padding: padding ? '16px' : 0,
      }}
    >
      {children}
    </div>
  );
}
